// @flow

import update from "immutability-helper";
import type {ReduxActionType} from "../../flow/ReduxActionType";

const INITIAL_STATE = {
    rules: [],
    pagination: {
        page: 0,
        limit: 20,
        total: 0
    },
    loading: true
};

type State = { type?: string };

const Rules = (state: State = INITIAL_STATE, action: ReduxActionType) => {
    switch (action.type) {
        case 'RULES_LOADED':
            return {...state, loading: false, rules: action.payload.rules, pagination: action.payload.pagination};

        case 'RULES_CHANGE_INPUT':
            const result = /(.*)\.(.*)?/.exec(action.payload.name);
            if (result) {
                const new_state = update(state, {
                    [result[1]]: {
                        [result[2]]: {
                            $set: action.payload.value
                        }
                    }
                });
                return {...new_state};
            }
            return update(state, {filters: {[action.payload.name]: {$set: action.payload.value}}});

        case 'RULES_REQUEST_FAILED':
            return {...state, loading: false};

        default:
            return {...state};
    }
};

export default Rules;
